export default __webpack_public_path__ + "static/media/logo_new.d68a4d08.png";